import axios from 'axios'
//import { MessageBox, Message } from 'element-ui'
//import { BModal, VBModal ,BVModalPlugin,BToast,ToastPlugin } from 'bootstrap-vue'
//import { BVToastPlugin } from 'bootstrap-vue'
// import Toastify from 'toastify-js'
// import "toastify-js/src/toastify.css"
//import store from '@/store'
import { getToken,getPhone } from '@/utils/auth'
import { genHashVerify } from '@/utils/genHash'
import baseUrl from './baseUrl'

// create an axios instance
const service = axios.create({
  //baseURL: process.env.VUE_APP_BASE_API || baseUrl, // url = base url + request url
  baseURL: baseUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers['content-type'] = "multipart/form-data";
    //console.log(config.headers)
    //$api_key.$key.$time.$msisdn.$otp.$password;
    let key = (Math.random() + 1).toString(36).substring(7);
    let otp = null
    let msisdn = null
    if(config.data){
      msisdn = !config.data.hasOwnProperty('msisdn') ? getPhone() : config.data.msisdn
      otp = !config.data.hasOwnProperty('otp') ? null : config.data.otp
    }
    let hash = genHashVerify(key,msisdn,otp)
    config.data['hash'] = hash;
    config.data['key'] = key;
    //console.log(config)
    if (getToken()) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers.Authorization = `Bearer ${getToken()}`;
        config.headers['User-Token'] = getToken();
        //if(config.url != 'api-v2/generate-otp') {
          config.data['token'] = getToken();
        //}
        
        //config.data['msisdn'] = getPhone();
        //console.log(config.data,getToken())
        //Content-Type
        //config.headers['access_token'] = getToken()
        config.headers['Access-Control-Allow-Origin'] = ['*']
        //config.headers['Origin'] = '*'
      }
    //console.log(config.headers['content-type'])
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    var path = window.location.pathname
    if ( res.code > 201 || res.status == 401) {
          // if (res.status == 401) {
          //   if (window.confirm('Bạn đã đăng xuất. Vui lòng đăng nhập lại?')) {
          //     store.dispatch('user/logout').then(() => {
          //       setTimeout(window.location = '/dang-nhap?redirect='+path,1000);
          //     });
          //   } else {
          //     store.dispatch('user/logout').then(() => {
          //       setTimeout(window.location = '/',1000);
          //     });
          //   }
          // }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
